(ns ui.enrich.sub
  (:require
   [re-frame.core :as rf]
   [ui.enrich.model :as model]))

(rf/reg-sub ::shown-processes (fn [db _] (model/shown-processes db)))
(rf/reg-sub ::running-count (fn [db _] (model/running-count db)))
(rf/reg-sub ::menu (fn [db _] (model/menu db)))

;; The request or job a screen started with its token.
(rf/reg-sub ::by-token (fn [db [_ token]] (model/by-token db token)))

;; The finished survey job the editor of a survey process applies.
(rf/reg-sub ::survey-job (fn [db [_ process-id]] (model/survey-job db process-id)))

(rf/reg-sub ::entity-in-progress?
            (fn [db [_ entity-id]] (model/entity-in-progress? db entity-id)))

;; The job under review, once its suggestions are loaded.
(rf/reg-sub ::reviewed-job
            (fn [db _]
              (when-let [result-id (model/reviewing db)]
                (let [job (model/job db result-id)]
                  (when (:loaded? job)
                    job)))))
